import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../auth';
import axios from '../../api/axios';
import Swal from 'sweetalert2';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, Col, Container, Image, ProgressBar, Row, Table } from 'react-bootstrap';
import { kemenkesLogoOnly, roomFlowFooter } from '../../assets/image/images';

function MeetingInformations() {

    const { tokens } = useContext(AuthContext);
    const [listMeeting, setListMeeting] = useState([]);
    const { token } = useParams();
    const navigate = useNavigate();

    // console.log(token)

    const retrieveMeeting = () => {

        axios.get(`/manage/display/informational/`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    'x-api-key': `${token}`,
                },

            })
            .then(res => {

                const today = new Date();
                const filteredTodayMeetings = res.data.filter((item) => {
                    const meetingStart = new Date(item.waktu_mulai);

                    return (
                        meetingStart.getUTCFullYear() === today.getUTCFullYear() &&
                        meetingStart.getUTCMonth() === today.getUTCMonth() &&
                        meetingStart.getUTCDate() === today.getUTCDate()
                    );
                });

                setListMeeting(filteredTodayMeetings);

            }).catch(err => {

                if (err.response?.status === 401 || err.response?.status === 403) {
                    // Token invalid, redirect to Not Found
                    navigate('/*');
                    // console.log(err.response)
                } else {
                    console.error(err);
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Gagal memuat data pada server!',
                    });
                }

            })
    };

    useEffect(() => {
        retrieveMeeting();
    }, []);

    // console.log(listMeeting)

    const intervalMinutes = 1;

    useEffect(() => {
        const intervalId = setInterval(() => {
            retrieveMeeting(false);
        }, intervalMinutes * 60000);

        return () => clearInterval(intervalId);
    }, []);

    const dateTime = new Date();

    // Get day name in Indonesian
    const dayName = dateTime.toLocaleDateString('id-ID', { weekday: 'long' });

    const formattedDate = dateTime.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });


    // Extract day, month, and year
    const [day, month, year] = formattedDate.split('/');

    // Map month numbers to Indonesian month names
    const monthNames = {
        '01': 'Januari',
        '02': 'Februari',
        '03': 'Maret',
        '04': 'April',
        '05': 'Mei',
        '06': 'Juni',
        '07': 'Juli',
        '08': 'Agustus',
        '09': 'September',
        '10': 'Oktober',
        '11': 'November',
        '12': 'Desember'
    };

    // Format the final output
    const formattedDateIndo = `${dayName}, ${day} ${monthNames[month]} ${year}`;

    const dataTableFake = [
        {
            "id": 240,
            "nama_meeting": "Project Kickoff",
            "waktu_mulai": "2025-04-09T08:00:00Z",
            "waktu_selesai": "2025-04-09T09:30:00Z",
            "online": true,
            "host": true,
            "link_meeting": "https://zoom.us/j/123456789",
            "pincode": "8432",
            "status": "approved",
            "attendaces": 5,
            "snack": true,
            "full_meal": false,
            "cost": "100.00",
            "finished": false,
            "user": 52,
            "ruangan": 2,
            "food": "Snack Box",
            "namaRuangan": "Ruang Online"
        },
        {
            "id": 241,
            "nama_meeting": "Weekly Standup",
            "waktu_mulai": "2025-04-10T03:30:00Z",
            "waktu_selesai": "2025-04-10T04:00:00Z",
            "online": false,
            "host": false,
            "link_meeting": "",
            "pincode": null,
            "status": "waiting",
            "attendaces": 8,
            "snack": false,
            "full_meal": false,
            "cost": "0.00",
            "finished": false,
            "user": 48,
            "ruangan": 3,
            "food": null,
            "namaRuangan": "Ruang Meeting Sedang"
        },
        {
            "id": 242,
            "nama_meeting": "Client Presentation",
            "waktu_mulai": "2025-04-11T10:00:00Z",
            "waktu_selesai": "2025-04-11T11:30:00Z",
            "online": true,
            "host": true,
            "link_meeting": "https://meet.google.com/xyz-defg-hij",
            "pincode": "5566",
            "status": "approved",
            "attendaces": 3,
            "snack": true,
            "full_meal": true,
            "cost": "200.00",
            "finished": false,
            "user": 51,
            "ruangan": 5,
            "food": "Catering",
            "namaRuangan": "Ruang Hybrid"
        },
        {
            "id": 243,
            "nama_meeting": "Internal Briefing",
            "waktu_mulai": "2025-04-12T07:00:00Z",
            "waktu_selesai": "2025-04-12T07:45:00Z",
            "online": false,
            "host": false,
            "link_meeting": "",
            "pincode": null,
            "status": "cancelled",
            "attendaces": 4,
            "snack": false,
            "full_meal": false,
            "cost": "0.00",
            "finished": true,
            "user": 49,
            "ruangan": 1,
            "food": null,
            "namaRuangan": "Ruang Briefing"
        },
        {
            "id": 244,
            "nama_meeting": "Sales Training",
            "waktu_mulai": "2025-04-13T13:00:00Z",
            "waktu_selesai": "2025-04-13T15:00:00Z",
            "online": true,
            "host": true,
            "link_meeting": "https://zoom.us/j/9988776655",
            "pincode": "7890",
            "status": "approved",
            "attendaces": 10,
            "snack": true,
            "full_meal": true,
            "cost": "150.00",
            "finished": false,
            "user": 55,
            "ruangan": 6,
            "food": "Buffet",
            "namaRuangan": "Ruang Virtual"
        },
        {
            "id": 245,
            "nama_meeting": "Budget Review",
            "waktu_mulai": "2025-04-14T02:00:00Z",
            "waktu_selesai": "2025-04-14T03:00:00Z",
            "online": false,
            "host": false,
            "link_meeting": "",
            "pincode": null,
            "status": "approved",
            "attendaces": 6,
            "snack": false,
            "full_meal": false,
            "cost": "0.00",
            "finished": false,
            "user": 50,
            "ruangan": 4,
            "food": null,
            "namaRuangan": "Ruang Meeting Kecil"
        },
        {
            "id": 246,
            "nama_meeting": "Marketing Sync",
            "waktu_mulai": "2025-04-15T05:00:00Z",
            "waktu_selesai": "2025-04-15T06:00:00Z",
            "online": true,
            "host": false,
            "link_meeting": "https://meet.google.com/abc-1234",
            "pincode": "1122",
            "status": "waiting",
            "attendaces": 7,
            "snack": true,
            "full_meal": false,
            "cost": "75.00",
            "finished": false,
            "user": 54,
            "ruangan": 2,
            "food": "Snack Box",
            "namaRuangan": "Ruang Online"
        },
        {
            "id": 247,
            "nama_meeting": "Design Review",
            "waktu_mulai": "2025-04-16T09:30:00Z",
            "waktu_selesai": "2025-04-16T10:30:00Z",
            "online": false,
            "host": true,
            "link_meeting": "",
            "pincode": null,
            "status": "approved",
            "attendaces": 2,
            "snack": false,
            "full_meal": false,
            "cost": "0.00",
            "finished": false,
            "user": 47,
            "ruangan": 3,
            "food": null,
            "namaRuangan": "Ruang Meeting Sedang"
        },
        {
            "id": 248,
            "nama_meeting": "Quarterly Report",
            "waktu_mulai": "2025-04-17T14:00:00Z",
            "waktu_selesai": "2025-04-17T15:30:00Z",
            "online": true,
            "host": true,
            "link_meeting": "https://zoom.us/j/44556677",
            "pincode": "3344",
            "status": "approved",
            "attendaces": 12,
            "snack": true,
            "full_meal": true,
            "cost": "250.00",
            "finished": false,
            "user": 53,
            "ruangan": 5,
            "food": "Catering",
            "namaRuangan": "Ruang Hybrid"
        },
        {
            "id": 249,
            "nama_meeting": "Team Retrospective",
            "waktu_mulai": "2025-04-18T11:00:00Z",
            "waktu_selesai": "2025-04-18T12:00:00Z",
            "online": false,
            "host": false,
            "link_meeting": "",
            "pincode": null,
            "status": "approved",
            "attendaces": 6,
            "snack": false,
            "full_meal": false,
            "cost": "0.00",
            "finished": false,
            "user": 48,
            "ruangan": 1,
            "food": null,
            "namaRuangan": "Ruang Briefing"
        },
        {
            "id": 250,
            "nama_meeting": "Team Retrospective II",
            "waktu_mulai": "2025-04-18T11:00:00Z",
            "waktu_selesai": "2025-04-18T12:00:00Z",
            "online": false,
            "host": false,
            "link_meeting": "",
            "pincode": null,
            "status": "approved",
            "attendaces": 6,
            "snack": false,
            "full_meal": false,
            "cost": "0.00",
            "finished": false,
            "user": 48,
            "ruangan": 1,
            "food": null,
            "namaRuangan": "Ruang Briefing 3"
        }
    ]

    const truncateText = (text, maxLength) => {
        return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
    };

    const [currentIndex, setCurrentIndex] = useState(0);
    const chunkSize = 4;
    const intervalTime = 10000;
    const totalChunks = Math.ceil(listMeeting.length / chunkSize);
    // const totalChunks = Math.ceil(dataTableFake.length / chunkSize);

    useEffect(() => {

        const tableInterval = setTimeout(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % totalChunks);
        }, intervalTime);

        return () => {
            clearTimeout(tableInterval);
        };
    }, [currentIndex, totalChunks]);

    const visibleData = listMeeting.slice(currentIndex * chunkSize, (currentIndex + 1) * chunkSize);
    // const visibleData = dataTableFake.slice(currentIndex * chunkSize, (currentIndex + 1) * chunkSize);

    return (
        <div id='bgMeetingInfo' style={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            width: '100vw',
            overflowX: 'hidden',
        }}>
            <div
                style={{
                    backgroundColor: '#000A2E',
                    height: '48px',
                    position: 'relative',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    border: 'none'
                }}
            >
                <div
                    style={{
                        display: 'inline-block',
                        paddingLeft: '100%',
                        animation: 'marquee 10s linear infinite',
                    }}
                >
                    <h1
                        style={{
                            fontFamily: 'Poppins-Medium',
                            fontSize: '30px',
                            color: 'white',
                            margin: 0,
                            display: 'inline',
                            marginBottom: '0px'
                        }}
                    >
                        SELAMAT DATANG
                    </h1>
                </div>

                <style>
                    {`
          @keyframes marquee {
            0% { transform: translateX(0%); }
            100% { transform: translateX(-100%); }
          }
        `}
                </style>
            </div>

            <div style={{
                backgroundColor: '#000A2E', height: '90px', position: 'relative',
            }}>

                <div
                    className='mt-4'
                    style={{
                        position: 'absolute',
                        left: '0%',
                        top: '60%',
                        transform: 'translateY(-50%)',
                        backgroundColor: '#000A2E',
                        borderBottomRightRadius: '20px',
                    }}>
                    <Image
                        className='p-3'
                        src={kemenkesLogoOnly}
                        width={110}
                        fluid
                    />
                </div>

                <Row className="h-100 align-items-center justify-content-center">
                    <Col lg={12} className="text-center">
                        <h1 className='mb-4 mt-4 text-white' style={{ fontFamily: 'Poppins-Medium', fontSize: '36px' }}>
                            KEMENTERIAN KESEHATAN REPUBLIK INDONESIA
                        </h1>
                    </Col>
                </Row>
            </div>

            <div style={{ textAlign: 'center', padding: '20px', fontFamily: 'Poppins-Medium' }}>
                <h5 style={{ fontSize: '37px' }}>JADWAL PERTEMUAN</h5>
                <h4 className='my-3' style={{ fontSize: '33px' }}>{formattedDateIndo}</h4>
            </div>

            <Container style={{
                height: '80vh', display: 'flex', flexDirection: 'column', overflowX: 'hidden',
                minWidth: '60vw',
                overflowY: 'hidden'
            }}>
                <div style={{
                    flex: 1, overflowY: 'hidden', maxHeight: '100%',
                    display: listMeeting.length !== 0 ? '' : 'flex',
                    justifyContent: listMeeting.length !== 0 ? '' : 'center',
                    alignItems: listMeeting.length !== 0 ? '' : 'center'
                    // display: dataTableFake.length !== 0 ? '' : 'flex',
                    // justifyContent: dataTableFake.length !== 0 ? '' : 'center',
                    // alignItems: dataTableFake.length !== 0 ? '' : 'center'
                }}
                >

                    {listMeeting.length === 0 ? (
                        // {dataTableFake.length === 0 ? (
                        <p className='text-muted' style={{ fontFamily: 'Poppins-Medium', fontStyle: 'italic', fontSize: '30px', textAlign: 'center' }}>
                            Belum ada jadwal meeting untuk hari ini
                        </p>
                    ) : (
                        <>
                            {/* {dataTableFake.length > 10 ?
                                // {dataTable.length > 5 ?
                                (
                                    <ProgressBar className='mx-auto' now={progress} animated variant="primary" style={{ height: "10px", borderRadius: "10px", width: '800px' }} />

                                )
                                :
                                (
                                    <></>
                                )
                            } */}
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                {visibleData.map((item, index) => {
                                    const globalIndex = currentIndex * chunkSize + index;
                                    const displayIndex = String(globalIndex + 1).padStart(2, '0');

                                    return (
                                        <Card
                                            key={globalIndex}
                                            style={{
                                                width: '700px',
                                                marginBottom: '30px',
                                                borderRadius: '12px',
                                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                                background: '#fafafa',
                                                border: 'none',
                                                // height: '200px',
                                                overflow: 'hidden'
                                            }}
                                        >
                                            <Row style={{
                                                fontFamily: 'Poppins-Regular',
                                                fontSize: '18px',
                                                color: '#333'
                                            }}>
                                                <Col lg={2} style={{
                                                    background: '#10b1aa',
                                                    flex: 1,
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    display: 'flex',
                                                    paddingLeft: '20px'
                                                    // height: '200px'
                                                }}>
                                                    <p style={{ color: 'white', fontSize: '64px' }}>
                                                        {displayIndex}
                                                    </p>
                                                </Col>
                                                <Col lg={10} style={{ color: '#222', padding: '20px' }}>
                                                    <p style={{ marginBottom: '0px', fontWeight: '500', fontSize: '30px' }}>
                                                        <strong>Nama Pertemuan:</strong>
                                                    </p>
                                                    <p style={{ marginBottom: '15px', fontSize: '30px' }}> {truncateText(item?.nama_meeting || '', 30)}</p>
                                                    <p style={{ marginBottom: '15px', fontSize: '30px' }}>
                                                        <strong>Ruangan:</strong> {item?.ruangan?.nama_ruangan}
                                                    </p>
                                                    <p style={{ fontSize: '30px' }}>
                                                        <strong>Waktu:</strong> {item?.waktu_mulai.split('T')[1].split('Z')[0].slice(0, 5)} s/d {item?.waktu_selesai.split('T')[1].split('Z')[0].slice(0, 5)}
                                                    </p>
                                                </Col>
                                            </Row>
                                        </Card>
                                    );
                                })}
                            </div>
                        </>
                    )}
                </div>
            </Container>

            {/* <div style={{
                textAlign: 'center',
                padding: '10px',
                marginTop: 'auto',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                fontFamily: 'Poppins-Regular'
            }}>
                <p className='my-auto'>
                    Managed by &nbsp;
                </p>
                <Image
                    fluid
                    width={100}
                    src={roomFlowFooter}
                />
            </div> */}
        </div >
    )
}

export default MeetingInformations

